
import { useIntersectionObserver } from "../../hooks/useIntersectionObserver";
import MediaPlanningContent from "./media-planning/MediaPlanningContent";
import MediaPlanningFeatures from "./media-planning/MediaPlanningFeatures";
import VideoPlayer from "../common/VideoPlayer";

const features = [{
  title: "Campaign Calendar View",
  description: "Easily schedule campaigns, track key dates, and ensure alignment with product launches and promotions."
}, {
  title: "Promotion & Product Launch Planning",
  description: "Seamlessly plan and coordinate promotions and product launches to help you execute on time and within budget."
}, {
  title: "Budget Allocation & Tracking",
  description: "Allocate your marketing dollars with precision, track performance in real time, and optimize your media plan for maximum ROI."
}];

const MediaPlanning = () => {
  // Use standard animation behavior for the container (animate once)
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true,
    resetOnEachView: false
  });
  
  return (
    <section className="pt-0 pb-6 md:py-6 px-0 md:px-6 bg-[#FAF9F8]">
      <div 
        ref={ref} 
        className={`max-w-7xl mx-auto bg-white p-6 md:p-12 rounded-xl transition-all duration-1000 transform ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-start">
          <MediaPlanningContent 
            label="PLAN"
            title="Streamline media planning"
            description="Plan campaigns, promotions, and product launches with ease using a flexible calendar view and efficient budget allocation tools."
            ctaText="Start Planning"
            ctaLink="https://app.plannifi.com/auth/sign-up"
          />
          
          <div className="order-2 md:order-2">
            <VideoPlayer 
              videoSrc="/lovable-uploads/3D-GLASS-BOX-ANIMATION.mp4"
              posterSrc="/lovable-uploads/3D-GLASS-BOX-ANIMATION.webm"
              altText="Media Planning visualization"
            />
          </div>
        </div>
        
        <MediaPlanningFeatures features={features} />
      </div>
    </section>
  );
};

export default MediaPlanning;
